import { useEffect, useState } from "react";
export const useFocus = <T extends HTMLElement>(
  ref: React.RefObject<T | null>,
  defaultState = false,
) => {
  const [state, setState] = useState(defaultState);

  useEffect(() => {
    const onFocus = () => setState(true);
    const onBlur = () => setState(false);
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const element = ref.current || null;
    if (element) {
      element.addEventListener("focus", onFocus);
      element.addEventListener("blur", onBlur);
    }

    return () => {
      if (element) {
        element.removeEventListener("focus", onFocus);
        element.removeEventListener("blur", onBlur);
      }
    };
  }, [ref]);

  return state;
};
